import { Card } from "@heroui/react";

export const WelcomeContainer = () => {
  return (
    <Card className="relative after:absolute after:w-full after:h-full after:top-0 after:left-0 after:bg-white/40 after:backdrop-blur-[3px] sm:after:backdrop-blur-[7px]">
      <div className="relative z-20 text-gray-800 p-4 py-8 sm:py-12 md:py-16">
        <div className="sm:px-6 md:px-8 lg:px-20 text-sm sm:text-base md:text-lg lg:text-xl text-center space-y-3 sm:space-y-4 max-w-4xl mx-auto">
          <p className="text-xl sm:text-2xl lg:text-3xl mb-4 sm:mb-6 font-semibold leading-tight">
            Welcome to Canada Prime Jobs (CPJ)!
          </p>
          <p className="leading-relaxed">
            You've entered our <span className="font-medium">Talent Pool</span>, where exciting job opportunities await.
          </p>
          <p className="leading-relaxed">
            Your journey starts with completing all <span className="font-medium">mandatory assessments</span>. These
            evaluations are
            <span className="font-medium"> crucial for increasing your score</span>, ensuring you meet employer
            expectations, and unlocking job opportunities.
          </p>
          <p className="leading-relaxed">
            Next, enhance your profile by completing <span className="font-medium">free training courses</span> tailored
            to your needs. These not only
            <span className="font-medium"> boost your score</span> but also provide a
            <span className="font-medium">recognized certificate</span>, increasing your chances of securing job offers.
          </p>
          <p className="leading-relaxed">
            A <span className="font-medium">higher score</span> means a higher likelihood of landing your dream job.
            Begin today to <span className="font-medium">stand out to employers</span>!
          </p>
        </div>
      </div>
    </Card>
  );
};
